function tokenClaim (token) {
  const parts = token.split('.')
  const claimBuff = Buffer.from(parts[1], 'base64')
  const claimString = claimBuff.toString('utf-8')
  const claim = JSON.parse(claimString)
  return claim
}

export default tokenClaim
